import { Col, Divider, Row } from "antd";
import React from "react";

import Container from "./Container";
import ChartsComponent from "../Charts";
import { FormattedMessage } from "react-intl";

const SixthBlock = ({ revenue, symbol, countryId }) => {
  const children = (
    <Row align={"stretch"}>
      <Col span={10}>
        <ChartsComponent
          label={<FormattedMessage id="bracestreatmentSaved" />}
          value1={Math.round(revenue.braces?.low)}
          value2={Math.round(revenue.braces?.high)}
          unit={symbol}
          countryId={countryId}
        />
      </Col>
      <Col span={2}>
        <Divider type="vertical" className="roi--divider-vertical" />
      </Col>
      <Col span={10}>
        <ChartsComponent
          label={<FormattedMessage id="alignertreatmentSaved" />}
          value1={Math.round(revenue.aligners?.low)}
          value2={Math.round(revenue.aligners?.high)}
          unit={symbol}
          countryId={countryId}
        />
      </Col>
    </Row>
  );
  return (
    <Container
      blockTitle={"revenuePerVisit"}
      title={"why"}
      content={"revenuePerVisitInfo"}
      children={children}
    />
  );
};

export default SixthBlock;
